import { render, staticRenderFns } from "./PartnerStats.vue?vue&type=template&id=7c774bc7&"
import script from "./PartnerStats.vue?vue&type=script&lang=js&"
export * from "./PartnerStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c774bc7')) {
      api.createRecord('7c774bc7', component.options)
    } else {
      api.reload('7c774bc7', component.options)
    }
    module.hot.accept("./PartnerStats.vue?vue&type=template&id=7c774bc7&", function () {
      api.rerender('7c774bc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/PartnerStats.vue"
export default component.exports